<template>
    <div class="charts charts--outer">
        <div v-show="fullStatus" style="min-width:385px; max-height:100%; margin-right:4px; margin-top:-8px; overflow:auto;">
            <income></income>
        </div>

		<div class="charts__row" :style="screenMode[activeMode][0]">
			<div class="charts__item" :style="screenMode[activeMode][1]">
				<chart
					@switchScreenMode="switchMode($event)"
					:typeProfit="'pointProfit'"
				>
				</chart>
			</div>
			<div :style="screenMode[activeMode][2]" class="charts__item">
				<router-link :to="{name: 'chart' , query: { chart: 'gridSt' }}" target="_blank">
					<i v-show="!fullStatus" class="icon-fullscreen"></i>
				</router-link>
				<chart
					@switchScreenMode="switchMode($event)"
					:title="'Чистый доход инвестора (MF 3% / SF 33,3%)'">
				</chart>
			</div>
		</div>
		<div  :style="screenMode[activeMode][3]" class="charts__row">
			<div :style="screenMode[activeMode][4]" class="charts__item" >
				<chart
					@switchScreenMode="switchMode($event)"
					:typeProfit="'pointLine'"
					:title="'Ср. доход инвестора в месяц (MF 3% / SF 33,3%)'">
				</chart>
			</div>
			<div class="charts__item" :style="screenMode[activeMode][5]">
				<chart

					@switchScreenMode="switchMode($event)"
					:typeProfit="'pointYear'"
					:title="'Ср. доход инвестора в год (MF 3% / SF 33,3%)'">
				</chart>
			</div>
		</div>
    </div>
</template>
<script>
import ProfitChartStrategy from './chart-strategy';
import ProfitOnMonth from '../chartsForTabs/profitMonthCharts/sig-profitability-chart-month';
import ProfitOnWeek from '../chartsForTabs/profitWeekCharts/sig-profitability-chart-week';
import IncomeWidget from '../leftNavigator/income-widget/income-block';
export default {
    data() {
        return {
            screenMode: {
                pointProfit:[{display:'flex', minHeight:100 + '%'},{maxWidth:100 + '%',height:100 + '%', flexBasis:100+'%'},{display:'none'},{display:'none'},{display:'none'},{display:'none'}],
                pointInvest:[{display:'flex', minHeight:100 + '%'},{display:'none'},{maxWidth:100 + '%',height:100 + '%', flexBasis:100+'%'},{display:'none'},{display:'none'},{display:'none'}],
                pointLine:[{display:'none'},{display:'none'},{display:'none'},{display:'flex', minHeight:100 + '%'},{maxWidth:100 + '%',height:100 + '%', flexBasis:100+'%'},{display:'none'}],
                pointYear:[{display:'none'},{display:'none'},{display:'none'},{display:'flex', minHeight:100 + '%'},{display:'none'},{maxWidth:100 + '%',height:100 + '%', flexBasis:100+'%'}],
                grid:['','','','','','']
            },
            activeMode:'grid',
        }
    },
    components: {
        'chart':ProfitChartStrategy,
        'month':ProfitOnMonth,
        'week':ProfitOnWeek,
        'income':IncomeWidget
    },
    props: {
        fullStatus: {default:false}
    },
    methods: {
        setMode(mode) {
            this.activeMode = mode;
        },
        switchMode(mode){
            if(mode.grid)
                this.setMode('grid')
            else
               this.setMode(mode.profit)
        }
    },
}
</script>
<style lang="less" scoped>
	.icon-fullscreen {
		position: absolute;
		font-size: 20px;
		right: 23px;
		color: #adc4e1;
		top: 89px;
		z-index: 1;
		cursor: pointer;
	}
</style>
